import React, { forwardRef } from 'react';
import { useNavigate } from "react-router-dom";
import './optionsPopUp.style.scss';

const OptionsPopup = forwardRef(({ position, onClose }, ref) => {

    const navigate = useNavigate();

    const navCurrentChallenges = () => {
        navigate('/currentchallenges')
    }

    const navTimeline = () => {
        navigate('/done')
    }

    const navMyChallenges = () => {
        navigate('/mychallenges')
    }

    return (
        <div ref={ref} className="options-popup" style={{ top: position.y, left: position.x }}>
            <ul>
                <li onClick={navCurrentChallenges}>Current Challenges</li>
                <li onClick={navTimeline}>Done Challenges</li>
                <li onClick={navMyChallenges}>My Challenges</li>
            </ul>
        </div>
    );
});

export default OptionsPopup;